import React, { useState, useContext } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { Brikk } from 'components/Brikk';
import { SearchInput } from 'components/form-elements/inputs/SearchInput';
import { Text } from 'components/typography';
import { useGetZones } from 'services/2n/zones';
import { PageLoader } from 'components/loaders/PageLoader';
import styles from '../styles.module.scss';
import { AccessManagement2NModalContext } from '../AccessManagement2NModalContext';
import { Resource } from './components/Resource';

export const Resources = () => {
  const [keyword, setKeyword] = useState('');
  const { setSelectedResource, setIsAddingResource } = useContext(AccessManagement2NModalContext);
  const intl = useIntl();
  const { zones, isLoading } = useGetZones();

  const formattedZones = zones.map((z) => ({
    id: z.Id,
    name: z.Name,
    devices: z.AccessPoints.map((accessPoint) => ({
      id: accessPoint.Device.Id,
      name: accessPoint.Device.Name,
    })),
  }));

  const filteredResources = !keyword ? formattedZones : formattedZones.filter(
    (group) => (group.name).toLowerCase().includes(keyword.toLowerCase()),
  );

  if (isLoading) return <PageLoader />;

  return (
    <div className={styles.container}>
      <Brikk.Heading
        heading="accessGroupsResourcesTitle"
      />
      <SearchInput
        placeholder={intl.formatMessage({ id: 'search' })}
        keyword={keyword}
        setKeyword={setKeyword}
      />
      <div className={styles.itemsList}>
        {
          filteredResources && filteredResources.length > 0
            ? filteredResources.map((resource, index) => (
              <Resource
                key={index}
                resource={resource}
              />
            ))
            : (
              <Text
                secondary
                center
                intl="noResourcesToDisplay"
                size={16}
              />
            )
        }
      </div>
      <div className={styles.formButtons}>
        <Button
          primary
          onClick={() => {
            setSelectedResource(true);
            setIsAddingResource(true);
          }}
        >
          {intl.formatMessage({ id: 'addNewResource' })}
        </Button>
      </div>
    </div>
  );
};
